import { registerGA4Subscriber } from '@/lib/eventBus/subscribers/ga4Subscriber'
import { registerRelewiseSubscriber } from '@/lib/eventBus/subscribers/relewiseSubscriber'

/** Wires every tracking vendor onto the shared eventBus, once, at app start. Adding a vendor is adding
 * a subscriber here — trigger sites (useTrackEvent) never need to know which vendors are listening. */
export const registerAnalyticsSubscribers = () => {
  const unsubscribers = [registerGA4Subscriber(), registerRelewiseSubscriber()]

  return () => unsubscribers.forEach((unsubscribe) => unsubscribe())
}
